import { createContext, ReactNode } from "react";

const AppContext = createContext({
  showModal: () => {},
  showPrivacySettings: () => {}
});
AppContext.displayName = "AppContext";

const AppTitleContext = createContext({
  pageTitle: <div>app title</div>,
  setPageTitle: (_title: ReactNode): void => {}
});
AppTitleContext.displayName = "AppTitleContext";

export { AppContext, AppTitleContext };
